export const PaymentPageOpts = {
  upgradeDelivery: 1,
  retryDelivery: 2,
  payDuties: 3,
  payInspection: 4,
  changePudoPoint: 5,
  missingID: 6,
  /** Generic SMS fee pages (parcels/payments/:page/...) — see config/smsFeePaymentPages.js */
  paySplitFee: 7,
};

export const BY_SMS = 'bys';
export const BY_EMAIL = 'bym';
